'use client';
import React from 'react';
import CarouselItem from './carousel-item';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const ClientCarousel = () => {
    return (
        <div className="bg-white dark:bg-black relative border-b dark:border-b-0 py-6 dark:py-0 lg:py-6 z-[1] overflow-hidden max-h-[140px] lg:max-h-[115px] lg:h-[115px]">
            <div className="container lg:container md:mx-auto ">
                <div className="row md:flex flex-nowrap items-center gap-3 gap-md-0">
                    <div className="col-span-auto flex-grow-0 flex-shrink-0 ">
                        <div className="text-base font-bold text-center lg:text-start sm:mb-[15px] md:mb-0">
                            Trusted by 500+ Clients
                        </div>
                    </div>
                    <div className="col-span-1 relative xl:max-w-full ">
                        <div className="client-carousel relative lg-h-[115px]">
                            <div className="client-logo-listing">
                                <Splide
                                    options={{
                                        type: 'loop',
                                        drag: 'free',
                                        arrows: false,
                                        pagination: false,
                                        autoWidth: true,
                                        perPage: 6,
                                        breakpoints: {
                                            1024: {
                                                perPage: 4,
                                            },
                                            600: {
                                                perPage: 3,
                                            },
                                            480: {
                                                perPage: 2,
                                            },
                                            420: {
                                                perPage: 1,
                                            },
                                        },
                                        autoScroll: {
                                            pauseOnHover: true,
                                            pauseOnFocus: false,
                                            rewind: false,
                                            speed: 0.7,
                                        },
                                    }}
                                    extensions={{ AutoScroll }}
                                >
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-beraw.svg'}
                                            // darkPath={'/img/clientlogo/originallogo/logo-beraw.svg'}
                                            width={140}
                                            height={44}
                                            alt="Let’s Be RAW"
                                            title="Let’s Be RAW"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-bfd.svg'}
                                            darkPath={'/img/clientlogo/ic-bfd-2x.webp'}
                                            width={203}
                                            height={40}
                                            alt="Buy Fine Diamonds"
                                            title="Buy Fine Diamonds"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-collectionat.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-collectionat.svg'}
                                            width={170}
                                            height={46}
                                            alt="Collection at"
                                            title="Collection at"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-catchup.svg'}
                                            // darkPath={'/img/clientlogo/darklogo/logo-dark-catchup.svg'}
                                            width={205}
                                            height={38}
                                            alt="Catch-Up"
                                            title="Catch-Up"
                                        />
                                    </SplideSlide>

                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-eaf.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-eaf.svg'}
                                            width={111}
                                            height={44}
                                            alt="EAFoods"
                                            title="EAFoods"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-eleganz.svg'}
                                            // darkPath={'/img/clientlogo/darklogo/logo-eleganz.svg'}
                                            width={185}
                                            height={40}
                                            alt="Eleganz"
                                            title="Eleganz"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-empower.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-empower.svg'}
                                            width={100}
                                            height={52}
                                            darkWidth={75}
                                            darkHeight={42}
                                            alt="Empower"
                                            title="Empower"
                                        />
                                    </SplideSlide>

                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-etms.svg'}
                                            // darkPath={'/img/clientlogo/darklogo/logo-dark-etms.svg'}
                                            width={165}
                                            height={40}
                                            alt="eTasks"
                                            title="eTasks"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-kalalimotors.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-kalalimotors.svg'}
                                            width={165}
                                            height={40}
                                            alt="Kalali Motors"
                                            title="Kalali Motors"
                                        />
                                    </SplideSlide>

                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-kingjadahotel.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-kingjadahotel.svg'}
                                            width={160}
                                            height={46}
                                            alt="King Jada Hotel"
                                            title="King Jada Hotel"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-kuke.svg'}
                                            width={110}
                                            height={50}
                                            alt="Kuke"
                                            title="Kuke"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-lexgroup.svg'}
                                            width={110}
                                            height={50}
                                            alt="LexHouse"
                                            title="LexHouse"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-mmc.svg'}
                                            width={110}
                                            height={50}
                                            alt="Meat Member Club"
                                            title="Meat Member Club"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-nafasi.svg'}
                                            width={150}
                                            height={40}
                                            alt="NafasiArt"
                                            title="NafasiArt"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-nextbigideaclub.svg'}
                                            width={110}
                                            height={50}
                                            alt="Next Big Idea"
                                            title="Next Big Idea"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-nuskin.svg'}
                                            width={150}
                                            height={50}
                                            alt="Nuskin"
                                            title="Nuskin"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-peswapay.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-peswapay.svg'}
                                            width={150}
                                            height={50}
                                            alt="PeswaPay"
                                            title="PeswaPay"
                                        />
                                    </SplideSlide>

                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-rth.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-rth.svg'}
                                            width={140}
                                            height={40}
                                            alt="RTH TV"
                                            title="RTH TV"
                                        />
                                    </SplideSlide>
                                    <SplideSlide>
                                        <CarouselItem
                                            path={'/img/clientlogo/originallogo/logo-vennotex.svg'}
                                            darkPath={'/img/clientlogo/darklogo/logo-dark-vennotex.svg'}
                                            width={120}
                                            height={52}
                                            alt="Vennotex"
                                            title="Vennotex"
                                        />
                                    </SplideSlide>
                                </Splide>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientCarousel;
